/* Legal Quiz — ecosistema. Trivia del hero, convenios y diagnóstico de grado. */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-lq]');
  var WA_NUMERO = (raiz && raiz.getAttribute('data-wa')) || '';

  /* ---------- scroll suave dentro de la página ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var t = document.getElementById(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  /* ---------- convenios ---------- */
  var REGIONES = [
    { nombre: 'Arica y Parinacota', u: ['U. de Tarapacá — Arica'] },
    { nombre: 'Antofagasta', u: ['U. Católica del Norte — Antofagasta'] },
    { nombre: 'Coquimbo', u: ['U. de La Serena — La Serena'] },
    { nombre: 'Valparaíso', u: ['PUCV — Valparaíso', 'UAI — Viña del Mar'] },
    { nombre: 'Metropolitana', u: ['U. de Chile', 'U. Adolfo Ibáñez', 'UDP', 'UDD', 'USS', 'U. Mayor', 'U. Finis Terrae', 'UNAB Bellavista', 'UNAB Casona', 'U. Bernardo O’Higgins', 'U. SEK'] },
    { nombre: 'Maule', u: ['U. de Talca — Talca'] },
    { nombre: 'Biobío', u: ['UNAB Concepción', 'UDD Concepción'] },
    { nombre: 'La Araucanía', u: ['U. de La Frontera — Temuco', 'U. Católica de Temuco'] },
    { nombre: 'Los Ríos', u: ['U. Austral de Chile — Valdivia', 'USS Valdivia'] },
    { nombre: 'Magallanes', u: ['USS Patagonia — Punta Arenas'] }
  ];

  var cajaRes = document.getElementById('resultados');
  var input = document.getElementById('q');
  var limpiar = document.getElementById('limpiar');

  function pintar(filtro) {
    if (!cajaRes) return;
    var q = (filtro || '').trim().toLowerCase();
    var html = '', total = 0;
    REGIONES.forEach(function (r) {
      var us = r.u.filter(function (x) {
        return !q || x.toLowerCase().indexOf(q) !== -1 || r.nombre.toLowerCase().indexOf(q) !== -1;
      });
      if (!us.length) return;
      total += us.length;
      html += '<div class="region"><h5>Región de ' + r.nombre + '</h5><div class="chips">' +
        us.map(function (x) { return '<span class="chip"><b>' + x + '</b></span>'; }).join('') +
        '</div></div>';
    });
    cajaRes.innerHTML = total ? html :
      '<div class="sin-resultado">Todavía no tenemos convenio con esa universidad. Habla con tu centro de alumnos: se firma en pocos días y toda la facultad accede al precio preferente.</div>';
  }

  if (input) input.addEventListener('input', function () { pintar(input.value); });
  if (limpiar) limpiar.addEventListener('click', function () { input.value = ''; pintar(''); });
  pintar('');

  /* ---------- trivia del hero ---------- */
  /* Para agregar preguntas: sumar objetos a cada arreglo, con el mismo formato. */
  var PREGUNTAS = {
    civil: [
      {
          tag: 'Civil · Nulidad absoluta',
          p: 'Quien celebró el contrato sabiendo el vicio que lo invalidaba quiere ahora alegar la nulidad absoluta. Según el art. 1683:',
          opts: [
            'Puede alegarla: la nulidad absoluta mira al interés general y la pide cualquiera.',
            'No puede alegarla, aunque tenga interés en ello.',
            'Puede alegarla, pero solo después de cuatro años.'
          ],
          ok: 1,
          just: 'El art. 1683 permite alegar la nulidad absoluta a todo el que tenga interés en ello, salvo justamente a quien ejecutó el acto o celebró el contrato sabiendo o debiendo saber el vicio que lo invalidaba.'
        },
        {
          tag: 'Civil · Nulidad absoluta',
          p: '¿En qué plazo se sanea la nulidad absoluta?',
          opts: [
            'No se sanea nunca: es imprescriptible.',
            'En cuatro años, igual que la nulidad relativa.',
            'En diez años, y nunca por ratificación de las partes.'
          ],
          ok: 2,
          just: 'El art. 1683 cierra señalando que la nulidad absoluta no puede sanearse por la ratificación de las partes, ni por un lapso que no pase de diez años. El cuadrienio del art. 1691 es de la nulidad relativa.'
        }
    ],
    procesal: [
      {
        tag: 'Procesal · Recursos',
        p: 'En juicio ordinario civil, el plazo para apelar de la sentencia definitiva es de:',
        opts: [
          'Cinco días desde la notificación.',
          'Diez días desde la notificación.',
          'Quince días desde la notificación.'
        ],
        ok: 1,
        just: 'El art. 189 del Código de Procedimiento Civil fija un término fatal de cinco días para apelar, que se aumenta a diez tratándose de sentencias definitivas.'
      },
      {
        tag: 'Procesal · Emplazamiento',
        p: 'En juicio ordinario, el demandado es notificado dentro del territorio jurisdiccional del tribunal ante el que se presentó la demanda. El término para contestar es de:',
        opts: [
          'Quince días.',
          'Dieciocho días.',
          'Dieciocho días más el aumento de la tabla de emplazamiento.'
        ],
        ok: 1,
        just: 'El art. 258 del CPC, en su texto vigente, fija dieciocho días cuando el demandado es notificado en el territorio jurisdiccional del tribunal. La antigua distinción entre quince y dieciocho días quedó atrás: el aumento de la tabla del art. 259 solo corre si el demandado está en un territorio diverso o fuera del país.'
      }
    ]
  };

  var LETRAS = ['A', 'B', 'C', 'D'];
  var qTag = document.getElementById('quizTag');
  var qP = document.getElementById('quizP');
  var qOpts = document.getElementById('quizOpts');
  var qFb = document.getElementById('quizFb');
  var qOtra = document.getElementById('quizOtra');
  var qContador = document.getElementById('quizContador');
  var ramoActual = 'civil';
  var indice = 0;

  function cargarPregunta() {
    if (!qOpts) return;
    var lista = PREGUNTAS[ramoActual];
    var d = lista[indice % lista.length];
    qTag.textContent = d.tag;
    qP.textContent = d.p;
    qFb.hidden = true;
    qOtra.hidden = true;
    qContador.textContent = lista.length > 1 ? ((indice % lista.length) + 1) + ' / ' + lista.length : '';
    qOpts.innerHTML = '';
    d.opts.forEach(function (texto, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'opt';
      b.innerHTML = '<b>' + LETRAS[i] + '</b> ' + texto;
      b.addEventListener('click', function () {
        qOpts.querySelectorAll('.opt').forEach(function (o, j) {
          o.disabled = true;
          if (j === d.ok) o.classList.add('bien');
        });
        if (i !== d.ok) b.classList.add('mal');
        qFb.innerHTML = (i === d.ok ? '<b>¡Correcta!</b> ' : '<b>No era esa.</b> La correcta es la ' + LETRAS[d.ok] + '. ') +
          d.just + ' <span class="quiz-cierre">Así mismo puedes practicar en la app: cada respuesta viene con su justificación.</span>';
        qFb.hidden = false;
        qOtra.hidden = lista.length < 2;
      });
      qOpts.appendChild(b);
    });
  }

  document.querySelectorAll('.ramo').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.ramo').forEach(function (o) {
        o.classList.remove('activo'); o.setAttribute('aria-selected', 'false');
      });
      t.classList.add('activo'); t.setAttribute('aria-selected', 'true');
      ramoActual = t.dataset.ramo;
      indice = 0;
      cargarPregunta();
    });
  });
  if (qOtra) qOtra.addEventListener('click', function () { indice++; cargarPregunta(); });
  cargarPregunta();

  /* ---------- diagnóstico de grado ---------- */
  var LECTURAS = {
    teoria: {
      titulo: 'Tu problema no es de materia: es de traducción',
      texto: 'Sabes la regla, pero no la conectas con los hechos. Eso no se arregla releyendo: se arregla resolviendo casos y siendo interrogada, porque la aplicación es una habilidad distinta de la memoria.',
      plan: 'Lo que te sirve: <b>interrogaciones semanales</b> con casos, más práctica diaria en la app entre sesión y sesión.'
    },
    cobertura: {
      titulo: 'Primero hay que cerrar la cobertura',
      texto: 'Antes de interrogar conviene ordenar un plan mes a mes hasta tu fecha, para no llegar con ramos sin ver. Interrogar materia que todavía no estudiaste desgasta y no mide nada.',
      plan: 'Lo que te sirve: <b>plan de estudio personalizado</b> primero, y las interrogaciones se suman cuando ya tengas la materia cubierta.'
    },
    bloqueo: {
      titulo: 'Sabes más de lo que logras mostrar',
      texto: 'El examen de grado no evalúa lo que sabes, evalúa lo que logras decir cuando te están mirando. Esa distancia solo se acorta exponiéndose muchas veces antes, en un lugar donde equivocarse no cuesta nada.',
      plan: 'Lo que te sirve: <b>interrogaciones semanales</b>. Es el escenario que estás evitando y el único que entrena esa habilidad.'
    },
    reprobe: {
      titulo: 'Repetir el mismo estudio suele dar el mismo resultado',
      texto: 'Lo primero no es estudiar más, es identificar qué falló: cobertura, aplicación o exposición. Son tres problemas distintos y se corrigen de formas distintas.',
      plan: 'Lo que te sirve: partir por una <b>sesión de coaching</b> para ubicar la causa, y de ahí armar el plan hasta tu nueva fecha.'
    },
    ritmo: {
      titulo: 'Es un problema de método, no de capacidad',
      texto: 'Estudiar muchas horas sin estructura cansa y rinde poco. Con bloques cortos, materias distribuidas y una revisión diaria de lo visto, la misma cantidad de horas rinde bastante más.',
      plan: 'Lo que te sirve: una <b>sesión de coaching</b> para ordenar la rutina, más la app para sostener el hábito diario.'
    }
  };

  /* El formulario lo dibuja la app (Globo / Powerful Form Builder).
     Acá solo leemos lo que la alumna respondió, para poder mostrarle su orientación
     después de enviar. Los datos los guarda la app; esto no los reemplaza. */

  var FRASES = {
    teoria: 'no logro aplicarla',
    cobertura: 'falta materia',
    bloqueo: 'me bloqueo',
    reprobe: 'reprob',
    ritmo: 'ritmo constante'
  };

  function textoEtiqueta(el) {
    var lab = el.closest('label');
    if (lab) return lab.textContent.trim();
    if (el.id) {
      var l = document.querySelector('label[for="' + el.id + '"]');
      if (l) return l.textContent.trim();
    }
    return (el.value || '').trim();
  }

  function tituloDelGrupo(el) {
    var g = el.closest('.globo-form-group, .globo-field, .form-group, .globo-element, fieldset, li');
    if (!g) return '';
    var l = g.querySelector('label, legend, .globo-label');
    return l ? l.textContent.replace(/\*/g, '').trim() : '';
  }

  function capturarRespuestas() {
    var cont = document.querySelector('.globo-formbuilder');
    if (!cont) return null;
    var campos = [], estado = '', crudo = '';

    cont.querySelectorAll('input, textarea, select').forEach(function (el) {
      var tipo = (el.type || '').toLowerCase();
      if (tipo === 'hidden' || tipo === 'submit' || tipo === 'button' || tipo === 'file') return;
      var valor = '';
      if (tipo === 'radio' || tipo === 'checkbox') {
        if (!el.checked) return;
        valor = textoEtiqueta(el);
      } else {
        valor = (el.value || '').trim();
        if (!valor) return;
      }
      crudo += ' ' + valor.toLowerCase();
      var titulo = tituloDelGrupo(el);
      var previo = campos.length ? campos[campos.length - 1] : null;
      if (previo && previo.titulo === titulo) previo.valor += ', ' + valor;
      else campos.push({ titulo: titulo, valor: valor });
    });

    Object.keys(FRASES).forEach(function (k) {
      if (crudo.indexOf(FRASES[k]) !== -1) estado = k;
    });

    return { campos: campos, estado: estado };
  }

  var contGlobo = document.getElementById('diagApp');
  if (contGlobo) {
    contGlobo.addEventListener('click', function (e) {
      var b = e.target.closest('button, input[type="submit"]');
      if (!b) return;
      var datos = capturarRespuestas();
      if (datos) { try { sessionStorage.setItem('lqDiag', JSON.stringify(datos)); } catch (err) { } }
    }, true);
  }

  function mostrarResultado() {
    var caja = document.getElementById('resultadoDiag');
    if (!caja) { console.warn('[LQ] falta #resultadoDiag'); return; }

    var datos = null;
    try { datos = JSON.parse(sessionStorage.getItem('lqDiag') || 'null'); } catch (e) { }
    var hayDatos = !!(datos && datos.campos && datos.campos.length);

    var l = (datos && LECTURAS[datos.estado]) || {
      titulo: 'Recibí tu diagnóstico',
      texto: 'Voy a revisar tu caso con calma y te escribo con el plan que te conviene según tu fecha de grado y el punto en que estás hoy.',
      plan: 'Si quieres adelantar, <b>escríbeme por WhatsApp</b> y lo vemos al tiro.'
    };

    var elT = document.getElementById('diagTitulo');
    var elX = document.getElementById('diagTexto');
    var elP = document.getElementById('diagPlan');
    if (elT) elT.textContent = l.titulo;
    if (elX) elX.textContent = l.texto;
    if (elP) elP.innerHTML = l.plan;

    var wa = document.getElementById('diagWa');
    if (wa) {
      if (WA_NUMERO && hayDatos) {
        var lineas = ['Hola Karen, completé el diagnóstico de grado.', ''];
        datos.campos.forEach(function (c) {
          lineas.push((c.titulo ? c.titulo + ': ' : '') + c.valor);
        });
        wa.href = 'https://wa.me/' + WA_NUMERO + '?text=' + encodeURIComponent(lineas.join('\n'));
      } else if (WA_NUMERO) {
        wa.href = 'https://wa.me/' + WA_NUMERO + '?text=' +
          encodeURIComponent('Hola Karen, acabo de enviar el diagnóstico de grado desde la web.');
      } else {
        wa.classList.add('oculto');
      }
    }

    /* el formulario solo se esconde si de verdad se envió con datos */
    if (hayDatos) {
      var app = document.getElementById('diagApp');
      if (app) app.classList.add('oculto');
      var nota = document.querySelector('#agenda .nota-form');
      if (nota) nota.classList.add('oculto');
      var intro = document.querySelector('#agenda .sec-head .lead');
      if (intro) intro.textContent = 'Listo. Esto es lo que veo con lo que me contaste.';
    }

    caja.hidden = false;
    caja.scrollIntoView({ behavior: 'smooth', block: 'start' });
    try { sessionStorage.removeItem('lqDiag'); } catch (e) { }

    var otro = document.getElementById('diagOtro');
    if (otro) {
      otro.addEventListener('click', function () {
        window.location = location.pathname + '#agenda';
      });
    }
  }

  if (location.search.indexOf('diag=ok') !== -1) {
    mostrarResultado();
  }
})();
